/**
 * PLEASE_SELECT
 * @type {[*]}
 */
export const PLEASE_SELECT = [
  {
    key: 0,
    text: '-- Please select --',
    value: ''
  }
];

/**
 * DAY FORMAT WITH TIME AND MERIDIAN
 * @type {string}
 */
export const DATE_TIME_MERIDIAN = 'YYYY/MM/DD hh:mm A';

/**
 * DATE FORMAT
 * @type {string}
 */
export const DATE_FORMAT = 'DD/MM/YYYY';

/**
 * DATE FORMAT
 * @type {string}
 */
export const MONTH_DATE_YEAR_FORMAT = 'MM/DD/YYYY';

export const RECURRINGS = PLEASE_SELECT.concat([
  { key: 0, text: 'No Recurring', value: 0 },
  { key: 1, text: 'Monthly', value: 1 },
  { key: 2, text: 'Quarterly', value: 2 },
  { key: 3, text: 'Semi-Annually', value: 3 },
  { key: 4, text: 'Annually', value: 4 }
]);

export const NOTIF_PERIODS = PLEASE_SELECT.concat([
  { key: 0, text: '30 Days', value: 0 },
  { key: 1, text: '1 week', value: 1 },
  { key: 2, text: '2 days', value: 2 },
  { key: 3, text: 'Same Day', value: 3 }
]);

export const DEFAULT_ASSIGNED_TO = [
  { key: 'Tim', text: 'Tim', value: 'Tim' },
  { key: 'Allen', text: 'Allen', value: 'Allen' },
  { key: 'Kris', text: 'Kris', value: 'Kris Wyckoff' },
  { key: 'Amy', text: 'Amy', value: 'Amy' },
  { key: 'Janelle', text: 'Janelle', value: 'Janelle' },
  { key: 'Test', text: 'Test', value: 'test' }
];

export const SEARCH_BY_NOTIFPERIODS = [
  { key: 7, text: '1 Week', value: 7 },
  { key: 30, text: '30 Days', value: 30 },
  { key: 90, text: '90 Days', value: 90 },
  { key: 180, text: '6 Months', value: 180 },
  { key: 365, text: 'Year', value: 365 },
  { key: 0, text: 'All', value: 0 }
]


// WEBPACK FOOTER //
// ./src/constants.js